"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityField = void 0;

var tslib_1 = require("tslib");

var ui_field_label_1 = require("@hopin-team/ui-field-label");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("./context");

var field_1 = require("./styled/field");

var root_1 = require("./styled/root");

var QuantityField = function QuantityField(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      children = _a.children,
      className = _a.className,
      hasErrors = _a.hasErrors,
      isRequired = _a.isRequired,
      label = _a.label,
      _b = _a.requiredText,
      requiredText = _b === void 0 ? 'required' : _b,
      _c = _a.sizeOption,
      sizeOption = _c === void 0 ? 'medium' : _c,
      isInline = _a.isInline,
      isInverse = _a.isInverse,
      rest = tslib_1.__rest(_a, ["__UIScope", 'data-testid', "children", "className", "hasErrors", "isRequired", "label", "requiredText", "sizeOption", "isInline", "isInverse"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'QuantityField',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var fieldId = (0, use_id_1.useId)();
  var hasSpinButton = react_1.Children.count(children) < 3;
  return react_1.default.createElement(root_1.Root, {
    isInline: isInline,
    className: rootClasses,
    "data-testid": testID
  }, react_1.default.createElement(context_1.QuantityFieldContext.Provider, {
    value: {
      fieldId: fieldId,
      hasSpinButton: hasSpinButton,
      sizeOption: sizeOption,
      isInverse: isInverse
    }
  }, label && react_1.default.createElement(ui_field_label_1.FieldLabel, {
    fieldId: fieldId,
    isRequired: isRequired,
    label: label,
    requiredText: requiredText,
    isInverse: isInverse,
    mb: 0.5
  }), react_1.default.createElement(field_1.Field, tslib_1.__assign({
    hasErrors: hasErrors,
    sizeOption: sizeOption,
    isInline: isInline,
    hasSpinButton: hasSpinButton,
    isInverse: isInverse
  }, rest), children)));
};

QuantityField.displayName = 'QuantityField';
var QuantityFieldWithSpace = (0, ui_helper_with_space_1.withSpace)(QuantityField);
exports.QuantityField = QuantityFieldWithSpace;